import { CountryCountry } from '@/em-api-client-typescript-fetch';

import { BrandConfigurationFactory } from '../common/interfaces/BrandConfigurationFactory';
import enGB from './locale/en-GB.json';
import enUS from './locale/en-US.json';
import fr from './locale/fr.json';
import it from './locale/it.json';

export const orientExpressBrandConfig: BrandConfigurationFactory = () => ({
  chainCode: 'orientexpress',
  themeKey: 'orientexpress',
  name: 'Orient Express',
  hotels: [
    {
      referenceId: 'orientexpress.laminerva-rome',
      code: 'orientexpress.laminerva-rome',
      name: 'La Minerva, Rome',
      dialect: 'ohip',
      openingDate: '2025-04-01',
    },
    {
      referenceId: 'orientexpress.palazzodonagiovannelli-venice',
      code: 'orientexpress.palazzodonagiovannelli-venice',
      name: 'Palazzo Donà Giovannelli, Venice',
      dialect: 'ohip',
      openingDate: '2026-04-01',
      visibility: {
        search: false,
      },
    },
    {
      referenceId: 'orientexpress.venezia-venice',
      code: 'orientexpress.venezia-venice',
      name: 'Palazzo Donà Giovannelli, Venice',
      dialect: 'ohip',
      openingDate: '2026-04-01',
    },
  ],
  homeUrl: 'https://orient-express.com',
  domains: [
    'booking.orientexpress.local',
    'orientexpress.dev.env.ennismore.com',
    'orientexpress.staging.env.ennismore.com',
    'bookhotels.orient-express.com',
    'orientexpress.ui.dev.ennismore.io',
    'orientexpress.ui.staging.ennismore.io',
    'orientexpress.ui.live.ennismore.io',
  ],
  i18n: {
    locales: ['en-GB', 'en-US', 'it', 'fr'],
  },

  maxRoomCountPerBooking: 7,

  search: {
    errorResolutionType: 'contact-button',
  },
  hideLanguageAndCurrencySelectorInBookingManagement: true,

  supportedRoomOccupancyConfigurations: [
    {
      adults: 1,
    },
    {
      adults: 1,
      children: 1,
    },
    {
      adults: 1,
      children: 2,
    },
    {
      adults: 2,
    },
    {
      adults: 2,
      children: 1,
    },
    {
      adults: 2,
      children: 2,
    },
    {
      adults: 3,
    },
    {
      adults: 3,
      children: 1,
    },
    {
      adults: 4,
    },
  ],
  legal: {
    urls: {
      en: {
        privacyPolicy: 'https://www.orient-express.com/en/privacy-policy',
        cookiePolicy:
          'https://www.orient-express.com/wp-content/uploads/2024/11/Orient-Express-Cookie-Policy-EN.pdf',
        termsOfUse:
          'https://api.orient-express.com/sites/default/files/2025-04/Orient%20Express%20Hotels%20-%20General%20Conditions%20of%20Booking%2001042025.pdf',
        contact: 'https://www.orient-express.com/contact/',
      },
      it: {
        privacyPolicy:
          'https://www.orient-express.com/it/informativa-sulla-privacy-di-orient-express',
        cookiePolicy:
          'https://www.orient-express.com/wp-content/uploads/2024/11/Orient-Express-Cookie-Policy_IT-1.pdf',
        termsOfUse:
          'https://api.orient-express.com/sites/default/files/2025-04/Orient%20Express%20Hotels-Condition%20of%20Booking-01042025-IT.pdf',
        contact: 'https://www.orient-express.com/contact/',
      },
      fr: {
        privacyPolicy:
          'https://www.orient-express.com/fr/politique-de-confidentialite-orient-express',
        cookiePolicy:
          'https://www.orient-express.com/wp-content/uploads/2024/11/Orient-Express-Politique-cookies-FR.pdf',
        termsOfUse:
          'https://api.orient-express.com/sites/default/files/2025-04/Orient%20Express%20Hotels%20-%20Conditions%20G%C3%A9n%C3%A9rales%20de%20R%C3%A9servation%2001042025%20-%20FR.pdf',
        contact: 'https://www.orient-express.com/contact/',
      },
    },
  },
  showRoomTotalInBreakdown: true,
  showTaxTotalInBreakdown: true,
  showAveragePricePerNight: true,
  showAddonDisclaimer: false,

  highlightedCountryCodes: [
    CountryCountry.FR,
    CountryCountry.IT,
    CountryCountry.NL,
    CountryCountry.GB,
    CountryCountry.US,
  ],

  features: {
    bookingManagement: true,
  },

  marketingEmailSignUpAtCheckout: false,
  collectPrivacyPolicyConsentAtCheckout: true,
  ohipDiscountCodeType: 'CORPORATE',

  translationOverrides: {
    'en-GB': enGB,
    'en-US': enUS,
    it,
    fr,
  },

  analytics: {
    gtm: {
      containerId: 'GTM-PWSQD8T',
    },
    cookieConsent: {
      provider: 'onetrust',
      oneTrustId: '01938ccc-690a-7e04-80e5-0937631d8261',
    },
  },
});
